import { PATHS } from "App/router";
import { FC, useCallback } from "react";
import { Card, LinkButton, Title } from "shared/components";
import { FlexChildren } from "shared/components/Form/Fieldset/styles";
import { Spacer } from "shared/layout";
import { CenterContent, CenteredText, MutedText } from "shared/styles";
import { BreakpointSize, ContentWidth } from "shared/styles/constants";
import { useBreakpoint } from "shared/utils";
import { StringParam, useQueryParams } from "use-query-params";

interface Props {
  title: string;
}

export const LoginOrRegister: FC<Props> = ({ title }) => {
  const [query] = useQueryParams({
    destination: StringParam,
  });

  const isMobile = useBreakpoint(BreakpointSize.m);

  const enrichedLink = useCallback(
    (link: string) => {
      if (query.destination) {
        return `${link}?destination=${query.destination}`;
      }

      return link;
    },
    [query.destination]
  );

  return (
    <CenterContent width={ContentWidth.wide}>
      <Spacer size="xxxl" align="center">
        <Title size="huge">
          <CenteredText>{title}</CenteredText>
        </Title>

        <FlexChildren
          style={{
            gap: "2rem",
            alignItems: "normal",
            width: "100%",
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          <Card>
            <Spacer size="l" justifyContent="space-between">
              <Title size="xxxl">
                <CenteredText style={{ width: "100%" }}>
                  Already have an account on the new (v2) platform?
                </CenteredText>
              </Title>
              <CenteredText style={{ width: "100%" }}>
                <MutedText>
                  If you've already signed up on the new version (v2, black
                  platform – app.tourmanagement.com), log in to accept the
                  invite.
                </MutedText>
              </CenteredText>
              <LinkButton to={enrichedLink(PATHS.LOGIN)} size="l" isFullWidth>
                Log in
              </LinkButton>
            </Spacer>
          </Card>

          <Card>
            <Spacer size="l" justifyContent="space-between">
              <Title size="xxxl">
                <CenteredText style={{ width: "100%" }}>
                  Used the old (v1) platform or <br />
                  never signed up?
                </CenteredText>
              </Title>
              <CenteredText style={{ width: "100%" }}>
                <MutedText>
                  Even if you had an account on the old (v1, white platform –
                  account.tourmanagement.com), you'll need to create a new
                  account for v2.
                </MutedText>
              </CenteredText>
              <LinkButton
                to={enrichedLink(PATHS.REGISTER)}
                size="l"
                isFullWidth
              >
                Sign up
              </LinkButton>
            </Spacer>
          </Card>
        </FlexChildren>
      </Spacer>
    </CenterContent>
  );
};
